module.exports = __webpack_public_path__ + "img/26-white.4a158cc9.svg";